// extracted by mini-css-extract-plugin
export default {"plot":"kPjt3HGH","legend":"Ped5JbVI","pill":"y5PL8qVL"};